import { render, staticRenderFns } from "./CookiesDisclaimer.vue?vue&type=template&id=99050162&scoped=true&"
import script from "./CookiesDisclaimer.vue?vue&type=script&lang=js&"
export * from "./CookiesDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./CookiesDisclaimer.vue?vue&type=style&index=0&id=99050162&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99050162",
  null
  
)

export default component.exports